

const generateVariedTimestamp = () => new Date(Date.now() - Math.random() * 100000000).toISOString();
const baseDay = new Date(generateVariedTimestamp()); // Convert to Date object
const dayOffSet = (noOfDays) => new Date(baseDay.getTime() - (noOfDays * 86400000)).toISOString();


export const tourInsightsAnalytics = () => {

  return ({
    buyerEngagementLevel: "high",
    dsrViewsByGuests: 7,
    pageNumberCount: 7,
    pageViewsByGuests: 7,
    totalDsrEngagementTimeSeconds: 3756,
    uniqueGuestVisitors: 1
  })

}

export const tourActivityLog = () => {

  return (
    [
      {
        activityLogDate: dayOffSet(1) ,
        activityArray: [
          {
            eventType:"tour-enters-dsr",
            eventTimestamp: generateVariedTimestamp(),
            visitedPageName: "Pricing",
            engagementDurationSeconds: "950",
            tourMemberName: "Ruth M",
            tourMemberProfilePicSrc: ""
          },
          {
            eventType:"tour-enters-dsr",
            eventTimestamp: generateVariedTimestamp(),
            visitedPageName: "Product Offering & Proposal",
            engagementDurationSeconds: "1250",
            tourMemberName: "Tim H",
            tourMemberProfilePicSrc: ""
          },
          {
            eventType:"tour-enters-dsr",
            eventTimestamp: generateVariedTimestamp(),
            visitedPageName: "Overview",
            engagementDurationSeconds: "267",
            tourMemberName: "Ruth M",
            tourMemberProfilePicSrc: ""
          }
        ]
      },
      {
        activityLogDate: dayOffSet(0),
        activityArray: [
          {
            eventType:"tour-enters-dsr",
            eventTimestamp: generateVariedTimestamp(),
            visitedPageName: "Overview",
            engagementDurationSeconds: "126",
            tourMemberName: "Tim H",
            tourMemberProfilePicSrc: ""
          },
          {
            eventType:"tour-enters-dsr",
            eventTimestamp: generateVariedTimestamp(),
            visitedPageName: "FAQ",
            engagementDurationSeconds: "880",
            tourMemberName: "Iain L",
            tourMemberProfilePicSrc: ""
          }
        ]
      }
    ]
  )
}

export const guestActivityLog = () => {
  return (
    [
      {
        tourMemberProfilePicSrc:"",
        tourSupplementaryUserInfo:"Director, Customer Success",
        tourMemberName:"Ruth M",
        totalTimeInDsr: 590,
        userLastActive: dayOffSet(1)
      },
      {
        tourMemberProfilePicSrc:"",
        tourSupplementaryUserInfo:"Customer Success Officer",
        tourMemberName:"Iain L",
        totalTimeInDsr: 287,
        userLastActive: dayOffSet(0)
      },
      {
        tourMemberProfilePicSrc:"",
        tourSupplementaryUserInfo:"Procurement Officer",
        tourMemberName:"Tim H",
        totalTimeInDsr: 120,
        userLastActive: dayOffSet(0)
      }
    ]
  )
}

export const pageActivityLog = () => {
  return (
    [
      { 
        pageIdentifier:"abc123", 
        pageTitle:"Pricing", 
        pageTotalEngagementTime:650, 
        pageUniqueViews:4, 
        pageUniqueVisitors:2, 
        pageUniqueViewsBreakdown:[
          { 
            tourMemberName:"Ruth M", 
            visitorEngagementTimeSeconds: 250, 
            visitorSessonCount: 3
           },
           { 
            tourMemberName:"Tim H", 
            visitorEngagementTimeSeconds: 110, 
            visitorSessonCount: 1
           }
        ]
      },
      { 
        pageIdentifier:"xyz123", 
        pageTitle:"Overview", 
        pageTotalEngagementTime:180, 
        pageUniqueViews:3, 
        pageUniqueVisitors:3, 
        pageUniqueViewsBreakdown:[
          { 
            tourMemberName:"Ruth M", 
            visitorEngagementTimeSeconds: 250, 
            visitorSessonCount: 1
           },
           { 
            tourMemberName:"Tim H", 
            visitorEngagementTimeSeconds: 110, 
            visitorSessonCount: 1
           },
           { 
            tourMemberName:"Iain L", 
            visitorEngagementTimeSeconds: 57, 
            visitorSessonCount: 1
           }
        ]
      }
    ]
  )
}